import React , {useEffect} from 'react';
import './Gallery.css'

function Gallery() {
  useEffect(()=> {
    document.title = "LeeBakes - Gallery"
  })
  let cardwidth = "400";
  return (
    <>
   <div style={{textAlign:"center"}}>
   <h1 className='mx-4 my-3'>Some of My Best Selling <span style={{color:"#0a58ca"}}>Items!</span></h1>
   </div>
   <div className="center-div" data-aos="zoom-out">
    <div className="grid-div">
      <div className="grid-item">
        <img src="https://images.pexels.com/photos/291528/pexels-photo-291528.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="error" className='img-fluid img-g'/>
        <label className='label'>Chocolate Pastery</label>
      </div>
      <div className="grid-item">
        <img src="https://images.pexels.com/photos/45202/brownie-dessert-cake-sweet-45202.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="error" className='img-fluid img-g' />
        <label className='label'>Browney</label>
      </div>
      <div className="grid-item">
        <img src="https://images.pexels.com/photos/1126359/pexels-photo-1126359.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="error" className='img-fluid img-g'  />
        <label className='label'>Rose Butter cake</label>
      </div>
    </div>
   </div>
    </>
  )
}

export default Gallery